import { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css';
import 'leaflet-defaulticon-compatibility';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import RestaurantContext from '../../Context/RestaurantContext';
import styled from 'styled-components';
import Image from 'next/image';
import dummyPic from './img/map-dummy.jpg';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  &&& .leaflet-pane {
    z-index: 98;
  }
`;

const MapsNoConsentWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const AcceptConsentOverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  & > span {
    color: white;
    text-shadow: 0px 0px 10px rgb(0, 0, 0);
    font-size: 20px;
  }
`;

function GMapsComponent({ position }) {
  const [isLoaded] = useState(true);

  const { cookieConsent, removeCookieConsent } = useContext(RestaurantContext);

  if (!cookieConsent || !cookieConsent.acceptAll) {
    return (
      <MapsNoConsentWrapper onClick={removeCookieConsent}>
        <Image
          src={dummyPic}
          alt="Map of restaurant"
          fill
          sizes="100vw"
          style={{
            objectFit: 'cover',
            objectPosition: 'center center',
          }}
        />
        <AcceptConsentOverlayWrapper>
          <span>Cookies müssen zur Darstellung akzeptiert werden</span>
        </AcceptConsentOverlayWrapper>
      </MapsNoConsentWrapper>
    );
  }

  L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

  return isLoaded ? (
    <Wrapper>
      <MapContainer
        center={position}
        zoom={14}
        doubleClickZoom={true}
        scrollWheelZoom={true}
        attributionControl={true}
        zoomControl={false}
        style={{ width: '100%', height: '100%', zIndex: 98 }}
        gestureHandling={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a> contributors'
          url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=1be6dae6-5e56-40ad-9529-899f066aaa4e"
        />
        <Marker position={position} />
      </MapContainer>
    </Wrapper>
  ) : (
    <div>Lade Karte...</div>
  );
}

GMapsComponent.propTypes = {
  position: PropTypes.exact({ lat: PropTypes.number, lng: PropTypes.number }).isRequired,
};

export default GMapsComponent;
